<template>
  <nav>
    <v-menu
      data-testid="notification-icon"
      offset-y
      rounded="xxl"
      :close-on-content-click="false"
      left
    >
      <template v-slot:activator="{ on: menu }">
            <v-btn
              rounded
              data-testid="notification-button"
              elevation="0"
              v-on="{ ...menu }"
              @click="markAllNotificationsAsSeen"
            >
              <v-icon>mdi-bell-outline</v-icon>  
              <v-badge color="error" offset-x="12" dot bordered v-if="notifications.length > 0 && !hasSeenNotifications"></v-badge>   
            </v-btn>
      </template>
      <v-card width="350" data-testid="notifications-card" >
        <!--<v-card-title>Notifications</v-card-title>-->
        <v-toolbar elevation="0">
          <v-toolbar-title class="text-body-1"> {{ $t('notificationsTitle') }}</v-toolbar-title>
          <v-spacer />
          <v-btn
            v-if="unreadNotificationCount > 0"
            ref="mark-read"
            text
            data-testid="mark-as-read-button"
            class="rounded-xxl text-none mark-read text-decoration-underline"
            :ripple="false"
            color="greytext"
            @click="markAllNotificationsAsRead"
          >
            {{ $t('markAllNotificationsRead') }}
          </v-btn>
        </v-toolbar>
        <v-divider> </v-divider>
        <v-list data-testid="menu-list" max-height="400" class="overflow-y-auto pa-0"  v-if="!loadingData && notifications.length > 0">
          <template v-for="(item, index) in notifications">
            <v-list-item
              data-testid="notification-id"
              :key="item.id"
              @click="markNotificationAsRead(item.id, item.attributes.data.url, item.attributes.type, item.attributes.data.model.title)"
              class="notification px-5"
              :class="{ 'pt-1': index == 0,  'pb-1': index == notifications.length-1, 'unread': item.attributes.read_at === null}"
            >
            <!--<img src="../assets/user_images/profile-avatar.png" >-->
              <v-list-item-avatar size="32" class="mr-1 align-self-start">
                <v-img
                  v-if="item.attributes.thumb == ''"
                  src="../assets/user_images/profile-avatar.png"
                />
                <v-img
                  v-else
                  :src="item.attributes.thumb"
                />
              </v-list-item-avatar>
              <v-list-item-content class="pa-2">
                <v-list-item-subtitle class="text-wrap darktext--text" v-html="item.attributes.message"></v-list-item-subtitle>
                <v-list-item-subtitle class="mt-1 text-wrap"><span class="date">{{ format_date(item.attributes.created_at) }}</span>&nbsp;&bull;&nbsp;<span data-testid="notification-tag" class="text-capitalize">{{item.attributes.tag}}</span> </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider
              :key="index"
              
            ></v-divider>
          </template>
          <div
            data-testid="scroll-notifications"
            v-if="notifications.length"
            v-observe-visibility="handleScrolledToBottom"
            class="align-center d-flex justify-center"
          >
            <v-progress-circular
              data-testid="show-more-notifications"
              v-if="page.hasMore"
              size="24"
              color="primary"
              class="bottom py-5"
            />
          </div>
        </v-list>
        <div style="height: 300px;" class="d-flex align-center pa-4" data-testid="empty-notification-card" v-else-if="!loadingData && notifications.length == 0">
          <span v-if="!error" class="text-center greytextlight--text text-subtitle-1 mx-auto"> {{ $t('noNotificationsText') }}</span>
          <span v-else class="text-center greytextlight--text text-subtitle-1 mx-auto"> <v-icon color="greytextlight">mdi-alert</v-icon> <br /> {{ $t('errorNotificationsText') }}</span>
        </div>
      </v-card>
    </v-menu>
  </nav>
</template>

<script>
import { getUserNotifications, markAllNotificationsAsSeen, markAllNotificationsAsRead, markNotificationAsRead } from '../api/userApi';
import { downloadWorkflowCertificate } from '../api/workflowApi';
import moment from 'moment'
import {eventBus} from '../eventbus'
import Echo from "laravel-echo"

export default {
    data(){
        return{
            loadingData: false,
            notifications: [],
            hasSeenNotifications: true,
            size: 10,
            page: {},
            notificationsInfo:[],
            error: false,
            userId: window.$cookies.get('id'),
            unreadNotificationCount:0
        }
    },
    mounted(){
      this.listen()
    },
    beforeDestroy() {
        eventBus.$off('changeUserLanguage')
    },
    async created(){
      this.loadingData = true
      await this.fetchUserNotifications()
      this.loadingData = false

      eventBus.$on('changeUserLanguage',async ()=>{
          this.notifications = []
          this.page = {}
          await this.fetchUserNotifications()
      })
    },
    methods:{
      listen() {
       
        if (this.token && !window.Echo) {
            window.Echo = new Echo({
                broadcaster: 'pusher',
                key: process.env.VUE_APP_PUSHER_KEY,
                cluster: 'eu',
                encryted: true,
                authEndpoint: process.env.VUE_APP_API_BASE_URL + "/v1/broadcasting/auth",
                auth: {
                    headers: {
                        'Accept': "application/vnd.api+json",
                        'Authorization': 'Bearer ' + this.token
                    }
                },
            });
        }
        if (window.Echo) {
          window.Echo.private('user.' + this.userId)
          .notification((notification) => {
              console.log(notification.type);
              this.fetchLastUserNotification()
          });  
        }
      },
      handleScrolledToBottom (isVisible) {
        if (!isVisible) {
          return
        }
        if (!this.page.hasMore) {
          return
        }
        this.fetchUserNotifications()
      },  
      async fetchLastUserNotification(){
        const response = await getUserNotifications(1, {})
        if(response.status){
          if(response.status == 200) {
            this.hasSeenNotifications = response.data.meta.notifications_seen
            this.unreadNotificationCount = response.data.meta.unread_notification_count
            this.notifications.unshift(response.data.data[0])
          }
        }        
      },

      async fetchUserNotifications(){
        try {
          const response = await getUserNotifications(this.size, this.page)
          if(response.status){
            if(response.status == 200) {
              this.notifications.push(...response.data.data)
              this.hasSeenNotifications = response.data.meta.notifications_seen
              this.page = response.data.meta.page
              this.unreadNotificationCount = response.data.meta.unread_notification_count
            }
          }            
        } catch (e) {
          if(e.response){
            this.error = true
          }            
        }
      },
      async markAllNotificationsAsRead(){
        const response = await markAllNotificationsAsRead()
        if(response.status){
          if(response.status == 200) {
            this.notifications.forEach(function(item) {
              item.attributes.read_at = Date.now()
            })
            this.unreadNotificationCount = 0
          }
        }            
      },
      async markAllNotificationsAsSeen(){
        const response = await markAllNotificationsAsSeen()
        if(response.status){
          if(response.status == 200) {
            this.hasSeenNotifications = true
          }
        }    
      },

      async markNotificationAsRead(id, url, type, title){
        await markNotificationAsRead(id)
        if(type == 'App\\Notifications\\CertificateIssuedNotification'){
          this.downloadCertificate(url.split('/').pop(), title)
        } else{
          window.location.href = process.env.VUE_APP_PROTOCOL + '://' + url
        }
      },

      format_date(value){
        if (value) {
          return moment(String(value)).format('DD MMM YYYY HH:mm')
        }
      },
      async downloadCertificate(workflowActionId, workflowTitle) {
          const response = await downloadWorkflowCertificate(workflowActionId);
          if (response.status) {
              if (response.status == 200) {
                  const url = window.URL.createObjectURL(new Blob([response.data]));
                  const link = document.createElement('a');
                  link.href = url;
                  let name = localStorage.user
                    ? JSON.parse(localStorage.user).first_name +
                      " " +
                      JSON.parse(localStorage.user).last_name
                    : "null";
                  link.setAttribute("crossorigin", "anonymous");
                  link.setAttribute("download", "Certificate_" + workflowTitle + "_" + name + ".pdf");
                  document.body.appendChild(link);
                  link.click();
              }
          }
      } 
    }
}
</script>